<template>
  <div>
    <van-cell-group v-if="iswx">
      <van-uploader :after-read="compressimg"
       deletable @delete="delImg" capture="environment"
       :accept="accept"
       v-model="value"
       :max-count="max_count"
       :max-size="6000000000" upload-text="上传照片" ></van-uploader>
    </van-cell-group>
    <div class="imgbox" v-if="!iswx">
      <div v-for="(img, k) in value" :key="k" class="imgAll">
        <van-image :src="img.url">
          <template v-slot:loading>
            <van-loading type="spinner" size="20" />
          </template>
          <template v-slot:error>
            加载失败
          </template>
        </van-image>
        <div v-if="img.loadstatus!=undefined && img.loadstatus != ''" class="imgts"><span>{{ img.loadstatus }}</span></div>
        <span class="delImg" @click="delImgApp(k)">+</span>
      </div>
      <div class="imgAll" @click="opencanmer" style="background-color: rgb(236, 236, 236);"><van-icon class="cimg" size="20" name="photo"></van-icon></div>
    </div>
    <van-overlay :show="show" z-index="999999999">
        <div class="wrapper">
          <van-loading text-color="#0094ff" >{{'上传中...'}}</van-loading>
        </div>
    </van-overlay>
  </div>

</template>

<script>
  import * as imageConversion from 'image-conversion';

export default {
  model:{
    prop:'value',
    event:'load'
  },
  data(){
    return{
      iswx: false,
      show: false
    }
  },
  props: {
    url: String,
    geturlbyid:String,
    w: {
      type: Number,
      default: 400
    },
    h: {
      type: Number,
      default: 300
    },
    transshape:{
      type:Boolean,
      default:false
    },
    quality: {
      type: Number,
      default: 0.5
    },
    max_count: {
      type: Number,
      default: 4
    },
    accept: {
      type: String,
      default:"image/*"
    },
    value:Array
  },
  created() {
    //用来判断是app应用还是h5应用，如果是h5应用设置iswx=true
    try {
      this.$jtp('checkApp', "iswx",);
    }catch (e) {
      this.iswx=true;
    }
  },
  methods: {
    compressimg(file) {
      this.show =true;
      // 大于1MB的jpeg和png图片都缩小像素上传 && file.file.size > 1000000  按时屏蔽大小设置
      console.log("图片类型:",file.file.type+""+file.file.size)
      let index=this.value.length-1;
      this.value[index].status = "uploading"
      this.value[index].message = "压缩中..."
      if (/\/(?:jpeg|png)/i.test(file.file.type) && file.file.size > 1000000) {
        imageConversion.compressAccurately(file.file, 400).then(fres => { // console.log(res)
          let filenew = new File([fres], file.name, { type: fres.type, lastModified: Date.now() })
          this.uploadimg(filenew)
        })
      } else {
        this.uploadimg(file.file)
      }
    },
    uploadimg(file)
    {
      let that = this;
      let index=this.value.length-1;
      // 最后将base64编码的图片保存到数组中，留待上传。
      if (this.url != undefined && this.url != '') {
        this.value[index].status = "uploading"
        this.value[index].message = "上传中..."
        //上传后端备齐一个上传表？还是答案提交采取单题模式？
        let data = new FormData();
        data.append('file', file);
        data.append('iswx',true);
        data.append('imgedata', null);
        console.log("begin:", this.value);
        let z = this.value[index];
        let v = this.value;
        this.$ajax.post(this.url, data).then(function (res) {
          if (res.code == 200) {
            z.status = '';
            z.message = '正在加载...';
            z.content = '';
            z.url = res.picUrl;
            that.$emit('load', v);
            //将图片保存到rides
            that.$emit('saveanswer');
            that.show =false;
          }
        });
      }
    },
    delImg(index) {
      this.$emit('load', this.value);
      //将图片保存到rides
      this.$emit('saveanswer');
    },
    //app应用调用方法
    opencanmer() {
      this.$jtp('openCameraFace', '', this.getpic);
      //this.getpic("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABKCAYAAAAc0MJxAAAEU0lEQVR4nO2azYscRRiHZ5Psh6AxEczGuBqMCZiQhEWXKH4gEk38gvXgxGwSzWR3trvemm1muqu6ExSh/R80InoQPJmTdz8QwYMH0Us8eFlBUYjk4O5011ujWB7WJbomm9ntj3cm1gO/e/0euot6q7tSsVgsFovFYrFYLBbLeohjs8mvmpuo19FzCFfvC0G9IQG/kKAvS0CzFI2CqYsS8D3fTSYdxwxSr5WEiOu9kumProhZPQJwPnDVqbhiNlCvvSTMQMD065Lr37uV9O/oL0NutlO3KBTPM8OSqQ/XJ+gfYfhjyNvj1H0KQ4J+P7OkK/klqqdj1J1yRwK2cpS0/GR9HcdmiLpbboTcbJeA7dxFLaVF3S83QsC3C5JkJOCvZx1zK3XHzLRqZosEVAWKMiF0GtQ9MyNBnyhSkgQ0AtRn1D0zIwHPFy1KAqpq1Wyk7poJCfhpCaKMD7iLumsmJMNvSxE115mg7poJCfhdGaLO8vRh6q6ZsKK6xIrqEiuqS0RZm7mb9Ptmrko5Hsg5dQ9110xIhm8VLUkApn1/4BSunipaVMjUJ9Q9MxN7ZrMETIsV1QHqnrkgIH2zOFHqUhSZW6g75oJki9sk6IVC9icXPep+uRJCp5H7Kwf6q3duxO99guG7OYr6KZpOdlB3KoS4aoYk6A9ykPSDZHo/dZ/CCbmOBGBnnZI+l2xxG3WH0jjHcXcIeEEw/LM7Qfr7AHS1UjED1GsnIXRxj2T6NQn4sQT8WYL+Y+lspBck4DcS8HzI8ekL/X7yzh8z0PfjiMXS+ziOGWzW26M+x93C1ftC3hn3WeeQ7yYTTWgfFHP6PtFQO6PpG2RM6RbPM8Ohi3sCVx2WLD0uuZoVgE43kaDO+G4y6bvJhOct3k7dJXdMxQz4gLsk4HMCVL1bMddLAOqUbKQPxvzSzdQdM1Gtmo2S6f3CTafyknP1dOpNt/3UzMxvt1F3XjORl44FPH2pWEEro+ohW3jE88wwdf/rElcvDgUNdbhcQSvCOi8HPL2L2sU1abXMFsn0MVJJf0dyNbv0ZabHRp6ono75oM5QC1oZ38Ejcdwjv1xHc8mOgKlpainXfhXbR8llNevtUdmDT9J/XkXAJ8kk1WrzI4Lpk9QSupelD5KIEgyPUpdfW1TdO3l5c6mS4poZkUwfpy/fbTr1iOu9pUpaplabHwkYPk8vYfUEXNWajrqbRNIycWw2+Cw9FKxhuC0zvptM9tQH0leb7dGA65JHllUEcTUjIHnAmB47cFYqS0Nwa7Y9HnBVo5QUcjzieSVv2ushrpmRANKHyhWWOAKSZ1pOcgd1/zXjOGbQd/SBANJqcYLU6RDUY/6M6b8rlqtxDsxW300mhKNfyHx5x9MpH9TjoqF2ko8mRRLHZpPP0jv9OX1AcPVo0MBnBU9fbLnpVOC2XxGgTvugTgSgq7KhJwNHPRE2OveHHt7Luenv20yLxWKxWCyW/yF/ARHrgT40KgDVAAAAAElFTkSuQmCC")
    },
    getpic(res) {
      this.value.push({ url: res });
      this.saveimg();
    },
    saveimg() {
      this.show = true;
      let index = this.value.length - 1;
      let that = this;
      this.value[index].loadstatus = '上传中...';
      if (this.url != undefined && this.url != '') {
        //上传后端备齐一个上传表？还是答案提交采取单题模式？
        let data = new FormData();

        data.append('file', new File([],''));
        data.append('iswx',false);
        data.append('imgedata', this.value[index].url);
        //f console.log('begin:', this.imgs);
        let z = this.value[index];

        let v = this.value;
        this.$ajax.post(this.url, data).then(function(res) {
          console.log(z);
          if (res.code == 200) {
            z.loadstatus = '';
            z.url=res.picUrl
            z.status = '';
            //  console.log("end",that.imgs);
            that.savefinish(index);
            //将图片保存到rides
            that.$emit('saveanswer');
            that.show = false;
          }
        });
      }
    },
    savefinish(index){
      let x=this.value[index];
      x.loadstatus='';
      this.$set(this.value,index,x);
    },
    delImgApp(index) {
      this.value.splice(index, 1);
      //将图片保存到rides
      this.$emit('saveanswer');
    },
  },

};
</script>

<style>
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .imgbox {
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
  }
  .imgbox img {
    width: 100px;
    height: 100px;
  }

  .imgAll {
    /*图片容器position: relative属性*/
    width: 100px;
    height: 100px;
    border: solid 1px #ccc;
    margin: 8px 5px;
    float: left;
    position: relative;
    box-shadow: 0 0 10px #eee;
    cursor: pointer;
  }
  .cimg {
    position: absolute;
    top: 40px;
    left: 40px;
    width: 20px;
    height: 20px;
  }
  .imgts {
    position: absolute;
    width: 100px;
    height: 100px;
    top: 0px;
    left: 0px;
    display: block;


    background: rgba(255,255,255,0.8);
    line-height: 22px;
    z-index: 90;
  }
  .imgts span{
    height: 100px;

    line-height: 100px;
    text-align: center;
    color: #000;
  }
  .delImg {
    position: absolute;
    top: -10px;
    right: -7px;
    width: 22px;
    height: 22px;
    background: #151718;
    border-radius: 50%;
    display: block;
    text-align: center;
    line-height: 22px;
    color: #fff;
    font-weight: 700;
    font-style: normal;
    cursor: pointer;
    /* Rotate div */
    transform: rotate(45deg);
    -ms-transform: rotate(45deg); /* Internet Explorer */
    -moz-transform: rotate(45deg); /* Firefox */
    -webkit-transform: rotate(45deg); /* Safari 和 Chrome */
    -o-transform: rotate(45deg); /* Opera */
  }
</style>



// WEBPACK FOOTER //
// src/components/common/uploadimg.vue